import { ACTION_TYPES } from '../../constants/store.constants';
import { getParsedTrackingDetails } from '../../helper/inviteHelper';
import { postGuestApi } from '../../service/guest.service';
import setErrorAction from './errorActions';

const setGuestInviteType = data => ({
  type: ACTION_TYPES.SET_GUEST_INVITE_TYPE,
  payload: data
});

const postGuestPatientAction = guestPayload => async dispatch => {
  try {
    dispatch({ type: ACTION_TYPES.SET_MENU_ITEM_DISABLE, payload: false });
    dispatch({ type: ACTION_TYPES.ENABLE_INVITE_BUTTON, payload: false });
    dispatch(clearLastSuccessfulInvites());
    const inviteGuestResponse = await postGuestApi(guestPayload);
    const parsedDetails = getParsedTrackingDetails(inviteGuestResponse, guestPayload);
    if (parsedDetails === null) {
      // display failed modal if invalid response
      dispatch(setErrorAction.setErrorHandler({ code: 14000 }));
      return false;
    }
    dispatch(setMultiInviteTrackingDetails(parsedDetails));
  } catch (err) {
    dispatch(setErrorAction.setErrorHandler(err));
  }
};

const setMultiGuestPatientInvitees = data => ({
  type: ACTION_TYPES.SET_MULTI_GUEST_PATIENT_INVITEES,
  payload: data
});

const setMultiInviteTrackingDetails = data => ({
  type: ACTION_TYPES.SET_MULTI_INVITE_TRACKING_DETAILS,
  payload: data
});

const clearMultiInviteTrackingDetails = () => ({
  type: ACTION_TYPES.CLEAR_MULTI_INVITE_TRACKING_DETAILS,
  payload: null
});

const setLastSuccessfulInvites = data => ({
  type: ACTION_TYPES.LAST_SUCCESSFUL_MULTI_INVITE_TRACKING_DETAILS,
  payload: data
});

const clearLastSuccessfulInvites = () => ({
  type: ACTION_TYPES.LAST_SUCCESSFUL_MULTI_INVITE_TRACKING_DETAILS,
  payload: []
});

export default {
  setGuestInviteType,
  setMultiGuestPatientInvitees,
  postGuestPatientAction,
  clearMultiInviteTrackingDetails,
  setLastSuccessfulInvites,
  clearLastSuccessfulInvites
};
